import React from "react";
import PropTypes from "prop-types";
import { useDispatch } from "react-redux";
import { Ul, AttributeItem } from "components/lists";
import { updatePatientComplianceDate } from "actions/patient";
import DayPicker from "react-day-picker";
import CalenderControls from "components/ui/date-picker/calender-controls";
import HasRolePermission from "components/shared/has-role-permission";
import { formatDate } from "utils/dates";

const ComplianceDate = ({ patientInfo, patientId, readOnly }) => {
  const [calenderIsOpen, setCalenderIsOpen] = React.useState();
  const dispatch = useDispatch();

  return (
    <div className="patient-schedule-dates-container">
      <h3
        style={{
          display: "flex",
          flex: 1,
          flexDirection: "row",
          fontSize: "1.4em",
          textTransform: "uppercase"
        }}
      >
        Compliance
      </h3>
      <Ul>
        <AttributeItem title="Outreach Date">
          {formatDate(patientInfo.outreach_date, "MM/DD/YYYY")}
        </AttributeItem>
        <AttributeItem title="Outreach Cycle">
          {patientInfo.outreach_cycle_count}
        </AttributeItem>
        <AttributeItem title="Override Outreach Date:">
          <div className="overide-date-checkbox-container">
            <input
              type="checkbox"
              style={{ margin: "5px 0px 0px 20px" }}
              checked={patientInfo.overrideEligibilityDate || false}
              disabled={!patientInfo.active}
              onChange={({ target: { checked } }) => {
                dispatch(
                  updatePatient({
                    patientId,
                    updates: {
                      overrideEligibilityDate: checked
                    }
                  })
                );
              }}
            />
          </div>
        </AttributeItem>

        {!patientInfo.override_outreach_date && (
          <React.Fragment>
            <div className="patient-outreach-date-controls">
              <HasRolePermission
                allowedRoles={[
                  "Administrator",
                  "SleepCoach",
                  "ServiceCoach",
                  "ServiceAdmin",
                  "OfficeAdministrator",
                  "CompanyAdministrator",
                  "ContractorAdministrator"
                ]}
              >
                <button
                  className="button secondary icon-button"
                  disabled={readOnly || !patientInfo.active}
                  onClick={() => {
                    dispatch(
                      updatePatientComplianceDate(patientId, {
                        auto_push: true,
                        update_forms: true
                      })
                    );
                  }}
                >
                  Push Outreach
                </button>
                <button
                  className="button secondary icon-button"
                  disabled={readOnly || !patientInfo.active}
                  onClick={() => setCalenderIsOpen(true)}
                >
                  Push Outreach Manual
                </button>
              </HasRolePermission>
            </div>
            <div className="date-picker container">
              {calenderIsOpen && (
                <div id={"datePicker"} className="entryContainer">
                  <div
                    className="outOfBounds"
                    onClick={() => setCalenderIsOpen(false)}
                  />
                  <div className="pickerContainer">
                    <DayPicker
                      onDayClick={day => {
                        if (!day) return;
                        const date = formatDate(day, "yyyy-MM-DD");
                        setCalenderIsOpen(false);
                        dispatch(
                          updatePatientComplianceDate(patientId, {
                            outreach_date: date,
                            update_forms: false
                          })
                        );
                      }}
                      containerProps={{ style: { padding: 0 } }}
                      selectedDay={patientInfo.outreach_date}
                    />
                    <CalenderControls
                      handleDayChange={day => {
                        if (!day) return;
                        const date = formatDate(day, "yyyy-MM-DD");
                        setCalenderIsOpen(false);
                        dispatch(
                          updatePatientComplianceDate(patientId, {
                            outreach_date: date,
                            update_forms: false
                          })
                        );
                      }}
                    />
                  </div>
                </div>
              )}
            </div>
          </React.Fragment>
        )}
      </Ul>
    </div>
  );
};

ComplianceDate.propTypes = {
  patientInfo: PropTypes.object.isRequired,
  readOnly: PropTypes.bool,
  patientId: PropTypes.string
};

export default ComplianceDate;
